import type { Networkish, SupWeb3Address } from "@/types";
import { useMemo } from "react";

import useAddressType, { type SupWeb3UserAddressType } from "@/hooks/api/useAddressType";
import useWeb3UserAddress from "@/hooks/web3/useWeb3UserAddress";
import { useSearchParams } from "next/navigation";

export default function useCheckRefundAddress(chainId: Networkish | undefined = undefined): {
  isLoading: boolean;
  isError: boolean;
  error: any;
  isValid: boolean | undefined;
} {
  const searchParams = useSearchParams();

  const userAddress = useWeb3UserAddress();

  const addressToCheck = useMemo(() => {
    const addressParam = searchParams.get("_userefundaddress") || "";
    if (addressParam) {
      return addressParam as SupWeb3Address;
    }
    return userAddress;
  }, [searchParams, userAddress]);

  const { data, isLoading, isError, error } = useAddressType(chainId, addressToCheck);

  return useMemo(
    () => ({
      isLoading,
      isError,
      error,
      isValid: !data ? undefined : (["EOA", "CREATE2 Contract"] as SupWeb3UserAddressType[]).includes(data),
    }),
    [data, error, isError, isLoading]
  );
}
